import * as Check from "@/inline-assets/check.svg";
import * as Download from "@/inline-assets/download.svg";
import * as Exclamation from "@/inline-assets/exclamation-mark.svg";
import * as Loading from "@/inline-assets/loading-ellipsis.svg";

export const IMPORT_ENUMS = {
  WONT: "WONT",
  WILL: "WILL",
  IS: "IS",
  DID: "DID",
  ERR: "ERR",
};

export const IMPORT_STATUSES = {
  [IMPORT_ENUMS.WONT]: {
    enum: IMPORT_ENUMS.WONT,
    color: "var(--shade1)",
    svg: Download.svg,
  },
  [IMPORT_ENUMS.WILL]: {
    enum: IMPORT_ENUMS.WILL,
    color: "var(--shade1)",
    svg: Loading.svg,
  },
  [IMPORT_ENUMS.IS]: {
    enum: IMPORT_ENUMS.IS,
    color: "var(--yellow)",
    svg: Loading.svg,
  },
  [IMPORT_ENUMS.DID]: {
    enum: IMPORT_ENUMS.DID,
    color: "var(--turq)",
    svg: Check.svg,
  },
  [IMPORT_ENUMS.ERR]: {
    enum: IMPORT_ENUMS.ERR,
    color: "var(--red)",
    svg: Exclamation.svg,
  },
};
